import { z } from "zod";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

export const RequestSource = z.enum(["reactive", "proactive"]);

export type RequestSource = z.infer<typeof RequestSource>;

export const RequestSourceMap: Record<RequestSource, string> = {
    reactive: "Member (reactive)",
    proactive: "Albertine (proactive)",
};
